import { ImportTutorCSV } from "../_models/Import/ImportModel";

export class ImportConstants {
  static readonly HEADER_ERROR_REGEX: RegExp = /Header with name '([^']+)'/g;
  static readonly UNASSIGN_GROUPS: string = "unassignGroups";
  static readonly UNASSIGN_COURSES: string = "unassignCourses";
  static readonly FILE_PROP: string = "file";
  static readonly FILES_PROP: string = "files";
  static readonly CSV_SAMPLE: string[] = [
    "Username,Password,Firstname,Lastname,Email,Group,Course,Organisation,Centre,LN02,ULN",
    'TestLearnerUserName1,Test_12345,Learner one,One Surname,TestLearnerUserName1@learner.com,"Test Group 1","NUM15-E3, ENG15-E3",Test Org  1,Test Centre 1,,',
    'TestLearnerUserName2,Test_12345,Learner two,Two Surname,TestLearnerUserName2@learner.com,"Test Group 1, Test Group 2","CY-E3",Test Org 2,Test Centre 2,,',
  ]; 
  static readonly CSV_TUTOR_SAMPLE: string[] = [
    "Username,Password,Firstname,Lastname,Email,Group,Organisation,Centre",
    'TestTutorUsername1,Test_12345,Tutor one,one Surname,TestTutorUsername1@learner.com,"Test Group 1",Test Org  1,Test Centre 1',
    'TestTutorUsername2,Test_12345,Tutor two,Two Surname,TestTutorUsername2@learner.com,"Test Group 2",Test Org  2,Test Centre 2',
    'TestTutorUsername2,,,,,"Test Group 3, default",Test Org  3,Test Centre 3',
    'TestTutorUsername2,,,,,"Test Group 4",Test Org  4,Test Centre 4', 
    'TestTutorUsername3,Test_12345,Tutor three,Three Surname,TestTutorUsername3@learner.com,"Test Group 3",Test Org  3,Test Centre 3',
  ]; 
  static readonly SAMPLE_LEARNER_FILENAME: string = "sample_learner_import.csv";
  static readonly SAMPLE_TUTOR_FILENAME: string = "sample_tutor_import.csv";
  static readonly BLOB_TYPE: string = "text/csv;charset=utf-8;";
  static readonly ATTR_DL: string = "download";
  static readonly NEWLINE: string = "\n";
  static readonly ANCHOR: string = "a";
  static readonly OPTION: string = "option";
  static readonly LIMIT_EXCEEDS: string = "File size exceeds the maximum allowed limit of 100MB";
  static readonly IMPORT_A_CSV_FILE: string = $localize`:@@import-a-csv-file:Importing a CSV file of data..`;
  static readonly PERCENT_COMPLETE: string = $localize`:@@percent-complete:% complete...`;
  static readonly FINISHED_WITH_ERROR: string = $localize`:@@finished-with-error:Finished with error`;
  static readonly COMPLETE_CHECK: string = $localize`:@@complete-check:Complete ✔`;
  static readonly IMPORTING_PREFIX: string = $localize`:@@importing-prefix:Importing `;
  static readonly OUT_OF: string = $localize`:@@out-of:out of`;
  static readonly REMOVE_FILE: string = $localize`:@@remove-file:Remove file`;
  
  static readonly SAMPLE_EXTERNAL_RESULTS_FILENAME: string = "sample_external_results_import.csv";
  static readonly CSV_EXTERNAL_RESULTS_SAMPLE: string[] = [
    "Username,Course,ResultLevel",
    'LearnerA,"NUM15","L2"',
    'LearnerA,"ENG15","L1"',
    'LearnerB,"NUM15","E3"',
  ];
  
  //stream related constants
  static readonly MESSAGE: string = "message";
  static readonly ERROR: string = "error";
  static readonly SSE_ERROR: string = "SSE encountered an error, closing stream...";
  static readonly STREAM_CLOSED_TUTOR: string = "Stream closed: Import Tutor";
  static readonly STREAM_CLOSED_LEARNER: string = "Stream closed: Import Learner";
}

export const ImportTutorCSVSample: ImportTutorCSV[] = [
  {
    username: "TutorUsername1", 
    password: "TestPassword12345",
    firstName: "John",
    lastName: "Doe",
    email: "tutor1@tutor.com",
    group: "Group 1",
    organisation: "Organisation 1",
    centre: "Centre 1",
    tooltip: $localize`:@@full-details-are-required:Full details are required for the tutor profile.`
  },
  {
    username: "TutorUsername1", 
    password: "",
    firstName: "",
    lastName: "",
    email: "",
    group: "Group 2",
    organisation: "Organisation 1",
    centre: "Centre 2",
    tooltip: $localize`:@@second-row-adds-new-group:Second row: Adds a new group for the same tutor under the same organisation but with a different centre and group.`
  },
  {
    username: "TutorUsername1", 
    password: "",
    firstName: "",
    lastName: "",
    email: "",
    group: "Group 3, Group 4",
    organisation: "Organisation 2",
    centre: "Centre 3",
    tooltip: $localize`:@@third-row-adds-new-group:Third row: Adds a new group for the tutor under a new organisation, including updated centre and group details.`
  },
  {
    username: "TutorUsername2", 
    password: "TestPassword12345",
    firstName: "Jane",
    lastName: "Doe",
    email: "tutor2@tutor.com",
    group: "Group 1",
    organisation: "Organisation 1",
    centre: "Centre 1",
    tooltip: $localize`:@@an-example-new-tutor:An example of a new tutor profile row`
  },
];

export const ImportMessageTranslations = {
  "Current user not found": "Defnyddiwr cyfredol heb ei ganfod",
  "Learner not found": "Dysgwr heb ei ganfod",
  "User is not allowed to Add Learner": "Nid yw'r defnyddiwr yn cael ychwanegu dysgwr",
  "User is not allowed to Assign/Unassigned Course": "Nid yw'r defnyddiwr yn cael aseinio/canslo aseiniad cwrs",
  "User is not allowed to Add Group": "Nid yw'r defnyddiwr yn cael ychwanegu grŵp",
  "No learner data found for import. Please verify your CSV file": "Dim data dysgwr wedi'u canfod ar gyfer mewnforio. Gwiriwch eich ffeil CSV os gwelwch yn dda",
  "File size exceeds the maximum allowed limit of 100MB": "Maint y ffeil yn fwy na'r terfyn uchaf o 100MB",
  "Invalid file format. CSV format is required": "Fformat ffeil annilys. Mae angen fformat CSV",
  "No file found": "Dim ffeil wedi'i ganfod",
  "No Error list found": "Dim rhestr gwallau wedi'i ganfod",
  "User is not associated with Organisation": "Nid yw'r defnyddiwr yn gysylltiedig â'r sefydliad",
  "Username is required.": "Mae angen enw defnyddiwr.",
  "Password is required.": "Mae angen cyfrinair.",
  "FirstName is required.": "Mae angen enw cyntaf.",
  "LastName is required.": "Mae angen cyfenw.",
  "Email is required.": "Mae angen e-bost.",
  "The field Username must be between 2 and 64 characters": "Rhaid i'r maes Enw Defnyddiwr fod rhwng 2 a 64 o gymeriadau",
  "The field FirstName must be between 2 and 64 characters": "Rhaid i'r maes Enw Cyntaf fod rhwng 2 a 64 o gymeriadau",
  "The field Email must be between 2 and 100 characters": "Rhaid i'r maes E-bost fod rhwng 2 a 100 o gymeriadau",
  "Username contains invalid characters": "Mae'r enw defnyddiwr yn cynnwys cymeriadau annilys",
  "8-16 characters, containing 3 out of 4 of: Lowercase/Uppercase characters, digits (0-9), and at least one special character": "8-16 o gymeriadau, yn cynnwys 3 allan o 4 o: Llythrennau bach/Mawr, digidau (0-9), ac o leiaf un cymeriad arbennig",
  "Firstname contains invalid characters": "Mae'r enw cyntaf yn cynnwys cymeriadau annilys",
  "Lastname contains invalid characters": "Mae'r cyfenw yn cynnwys cymeriadau annilys",
  "Please enter a valid email address": "Rhowch gyfeiriad e-bost dilys os gwelwch yn dda",
  "Name is required": "Mae angen enw",
  "The field Name must be between 2 and 100 characters": "Rhaid i'r maes Enw fod rhwng 2 a 100 o gymeriadau",
  "The Group name contains invalid characters.": "Mae enw'r grŵp yn cynnwys cymeriadau annilys.",
  "Centre is not associated with organisation.": "Nid yw'r ganolfan yn gysylltiedig â'r sefydliad",
  "Username and Email already exists.": "Mae enw defnyddiwr ac e-bost eisoes yn bodoli.",
  "Email already exists.": "Cyfeiriad e-bost eisoes yn bodoli.",
  "Username already exists." : "Enw defnyddiwr yn bodoli'n barod.",
  "Learner should only be associated to one organisation": "Dylai dysgwr fod yn gysylltiedig ag un sefydliad yn unig",
  "No Organisation Found": "Dim Sefydliad wedi'i Ganfod",
  "Learner should only be associated to one centre": "Dylai dysgwr fod yn gysylltiedig ag un ganolfan yn unig",
  "No Centre Found": "Dim Canolfan wedi'i Chanfod",
  "User not found": "Defnyddiwr heb ei ganfod",
  "Invalid Course Level": "Lefel Cwrs Annilys",
  "Invalid Course": "Cwrs Annilys",
  "No Course Level found": "Dim Lefel Cwrs wedi'i Ganfod",
  "Operation failed. Default Group not created": "Methwyd y gweithrediad. Ni chrewyd y Grŵp Rhagosodedig",
  "Group not created": "Ni chrewyd y Grŵp",
  "Learner has already been assigned to an Organisation.": "Mae dysgwr eisoes wedi'i aseinio i sefydliad.",
  "Logged user is not associated with Learner": "Nid yw'r defnyddiwr mewngofnodedig yn gysylltiedig â'r dysgwr.",
  "Group is required.": "Mae angen grŵp.",
  "8-16 characters, containing 3 out of 4 of: Lowercase/Uppercase characters, digits (0-9), and at least one special character.": "8-16 nod, yn cynnwys 3 allan o 4 o: llythrennau bach/llythrennau mawr, digidau (0-9), ac o leiaf un nod arbennig.",
  "The field Name must be between 2 and 64 characters": "Rhaid i'r maes Enw fod rhwng 2 a 64 o gymeriadau",
  "Course is required.": "Mae angen cwrs.",
  "ResultLevel is required.": "Mae angen Lefel Canlyniad.",
  "User is not allowed to Enter external IA results": "Ni chaniateir i ddefnyddiwr Mewnbynnu canlyniadau IA allanol",
  "Learner has already completed WEST initial assessment for {0}": "Dysgwr eisoes wedi cwblhau asesiad cychwynnol WEST ar gyfer {0}",
  "The course is not assigned to the learner": "Nid yw'r cwrs wedi'i neilltuo i'r dysgwr",
  "Previous assessment result already entered for the course": "Canlyniad asesiad blaenorol a gofnodwyd eisoes ar gyfer y cwrs",
  "Learner has already completed WEST initial assessment for the course": "Mae'r dysgwr eisoes wedi cwblhau asesiad cychwynnol WEST ar gyfer y cwrs",
  "Tutor not found": "Tiwtoriaid heb ei ganfod",
  "Tutor has already been assigned to an organisation": "Mae'r tiwtor eisoes wedi'i neilltuo i sefydliad",
  "Tutor has already been assigned to a centre": "Mae'r tiwtor eisoes wedi'i neilltuo i ganolfan",
  "Tutor edit failed. Selected tutor are associated with the organisation to which the current user does not have access.": "Methodd golygu'r tiwtor. Mae'r tiwtor a ddewiswyd yn gysylltiedig â'r sefydliad nad oes gan y defnyddiwr presennol fynediad iddo.",
  "One (1) organisation per row is required": "Mae angen un (1) sefydliad fesul rhes",
  "One (1) centre per row is required": "Mae angen un (1) canolfan fesul rhes",
  "Invalid action": "Gweithred annilys",
  "No action required - Learner is already enabled": "Dim angen gweithredu - mae'r Dysgwr eisoes wedi'i alluogi",
  "No action required - Learner is already disabled": "Dim angen gweithredu - mae'r dysgwr eisoes wedi'i analluogi",
  "You must disable an active account before it can be deleted": "Rhaid i chi analluogi cyfrif gweithredol cyn y gellir ei ddileu",
  "Learner is not associated with Organisation": "Nid yw'r dysgwr yn gysylltiedig â Sefydliad",
  "Learner is not associated with Centre": "Nid yw'r dysgwr yn gysylltiedig â'r Ganolfan"
}

export const generateImportErrorFileName = function(prefix: string = null) {
  const timestamp = new Date().toISOString().replace(/[-:]/g, '').split('.')[0];
  return `IMPORT_ERROR_CSV_${prefix != null ? prefix + "_" : "" }${timestamp}.csv`;
}
